import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {HttpModule} from '@angular/http';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {SpotifyTagsService} from './services/spotify-tags-service';
import {APPROUTES} from './app-routing.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {HomeComponent} from "./components/home/home.component";
import {TagsComponent} from "./components/tags/tags.component";
import {ArtistsComponent} from "./components/artists/artists.component";
import {AddArtistsComponent} from "./components/add-artists/add-artists.component";
import {SignupComponent} from "./components/signup/signup.component";
import {AuthGuardService} from "./authentication-guard/auth-guard.service";
import {EditTagModalComponent} from "./components/edit-tag-modal/edit-tag-modal.component";
import {AddTagModalComponent} from "./components/add-tag-modal/add-tag-modal.component";
import {ConfirmDeletionComponent} from "./components/confirm-deletion/confirm-deletion.component";
import {AlbumsComponent} from './components/albums/albums.component';
import {AddAlbumsComponent} from './components/add-albums/add-albums.component';
import {TagsListComponent} from './components/tags-list/tags-list.component';
import {FoldersListComponent} from './components/folders-list/folders-list.component';
import {AddFolderModalComponent} from './components/add-folder-modal/add-folder-modal.component';
import {FolderTagsComponent} from './components/folder-tags/folder-tags.component';
import {EditFolderModalComponent} from './components/edit-folder-modal/edit-folder-modal.component';
import {ExpandedFoldersService} from "./services/expanded-folders-service";
import {SynchroniseModalComponent} from './components/synchronize-modal/synchronise-modal.component';
import {AlertComponent} from './components/alert/alert.component';
import {NotFoundPageComponent} from './components/not-found-page/not-found-page.component';
import {HttpErrorInterceptor} from "./interceptors/error.interceptor";
import { NavigationComponent } from './components/navigation/navigation.component';
import { ScreensComponent } from './components/screens/screens.component';
import {LoadingInterceptor} from "./interceptors/loading.interceptor";
import { SkeletonsComponent } from './components/skeletons/skeletons.component';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        TagsComponent,
        ArtistsComponent,
        AddArtistsComponent,
        SignupComponent,
        AddTagModalComponent,
        EditTagModalComponent,
        ConfirmDeletionComponent,
        AlbumsComponent,
        AddAlbumsComponent,
        TagsListComponent,
        FoldersListComponent,
        AddFolderModalComponent,
        FolderTagsComponent,
        EditFolderModalComponent,
        SynchroniseModalComponent,
        AlertComponent,
        NotFoundPageComponent,
        NavigationComponent,
        ScreensComponent,
        SkeletonsComponent
    ],
    imports: [
        BrowserModule,
        HttpModule,
        HttpClientModule,
        RouterModule.forRoot(APPROUTES),
        ReactiveFormsModule
    ],
    providers: [SpotifyTagsService,
        AuthGuardService,
        ExpandedFoldersService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        }],
    bootstrap: [AppComponent]
})
export class AppModule {
}
